import React from 'react';
import { Wrapper } from './styled';

interface Props {
  color: string;
}

export const Alert: React.FC<Props> = ({ children, color }) => (
  <Wrapper color={color}>
    {children}
  </Wrapper>
)
